"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { motion } from "framer-motion";

export function ProductHeader() {
  return (
    <section className="relative min-h-[60vh] bg-gray-900 px-4 pt-20 pb-16 sm:px-6 lg:px-8">
      {/* Enhanced animated background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(59,130,246,0.2),transparent_50%),radial-gradient(circle_at_70%_60%,rgba(147,51,234,0.2),transparent_50%)]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent opacity-20" />
      </div>

      {/* Dynamic orbs */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 0.15, scale: 1 }}
        transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
        className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-primary blur-3xl"
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 0.1, scale: 1 }}
        transition={{ duration: 3, repeat: Infinity, repeatType: "reverse", delay: 1 }}
        className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-purple-500 blur-3xl"
      />

      <div className="mx-auto max-w-7xl">
        <div className="relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">
              Build Worlds, Not Just Stories
            </h1> {/* Updated Headline: More ambitious and benefit-oriented */}
            <p className="mx-auto mt-6 max-w-3xl text-xl text-gray-300">
              Omnigeist allows you to craft narratives in a single source, ready for any medium. From video games to graphic novels.
            </p>{/* Tagline to emphasize result + scope */}
          </motion.div>
          
          <div className="mt-10 max-w-4xl mx-auto">
            <div id="demo-video" className="relative w-full aspect-video rounded-lg shadow-lg overflow-hidden">
              <video className="absolute inset-0 w-full h-full object-cover" autoPlay loop muted playsInline controls>
                <source src="/assets/video/Omnigeist-Hero-Banner-Video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className="mt-10 flex justify-center gap-4">
            <Button 
              className="primary-button"
              onClick={() => window.location.href = '/contact?type=product'}
            >
              Get Started
            </Button>
            <Button 
              className="secondary-button"
              onClick={() => {
                document.getElementById('demo-video').scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Watch Demo
            </Button>
          </div>
        </div>
      </div>
      
      {/* Decorative background elements */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20" />
        <div className="absolute inset-y-0 right-0 w-1/2 bg-gradient-to-l from-blue-500/10 to-transparent" />
      </div>
    </section>
  );
}